import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { authMiddleware, mondayBoards } from "@onesolution/middlewares";

import type { MONDAY_TYPES } from "@onesolution/monday";
import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseMutation } from "..";

const AddMessageMutationParams = z.object({
	operationId: z.string(),
	message: z.string(),
});

export type AddMessageMutationVariables = z.infer<
	typeof AddMessageMutationParams
>;

export type PriceForOpCreation = MONDAY_TYPES["base"] & {
	channel: MONDAY_TYPES["status"];
	jobs: MONDAY_TYPES["dropdown"];
	prices: MONDAY_TYPES["text"];
	workflowSteps: MONDAY_TYPES["dropdown"];
};

const handler = createServerFn({ method: "POST" })
	.middleware([authMiddleware, mondayBoards])
	.validator(AddMessageMutationParams)
	.handler(async ({ data: { message, operationId } }) => {
		return mondayClient.mutation.createUpdate({
			body: message,
			itemId: operationId,
		});
	});

export const addMessageOnServer = wrapWithUseMutation<
	typeof handler,
	AddMessageMutationVariables
>(handler);
